import React from "react";
import { Link } from "react-router-dom";
import SearchBar from "./SearchBar";

function NavLinks() {
  return (
    <div className="w-full flex flex-row items-center justify-around col-span-2 md:flex-col md:gap-7 md:w-2/3">
      <ul className="hidden md:w-full lg:text-sm xl:text-lg md:flex md:justify-around lg:justify-center lg:items-center lg:gap-12">
        <li className="hover:text-sky-600 font-semibold">
          <Link to={"/activities"}>Activities</Link>
        </li>
        <li className="hover:text-sky-600 font-semibold">
          <Link to={"/about"}>About Us</Link>
        </li>
        <li className="hover:text-sky-600 font-semibold">
          <Link to={"/committee"}>Committee</Link>
        </li>
        <li className="hover:text-sky-600 font-semibold">
          <Link to={"/gallery"}>Gallery</Link>
        </li>
        <li className="hover:text-sky-600 font-semibold">
          <Link to={"/contact"}>Contact Us</Link>
        </li>
      </ul>
      <SearchBar />
    </div>
  );
}

export default NavLinks;
